import ApiService from "service/Api";

interface RaffleAncolPayloadTypes {
  rewardName: string;
  description: string;
  qty: number;
  activePerieodeStart: string;
  activePerieodeEnd: string;
  isMultipleDraw: string;
  rewardImage?: File | null;
}

const RaffleAncolService = {
  getAllRaffleAncol: async (
    page: number,
    search: string,
    limit: number
  ) => {
    const requestData = {
      method: "get",
      headers: {
        "Content-Type": "application/json; charset=utf-8",
      },
      params: {
        search: search,
        page: page,
        per_page: limit,
      },
      url: "admin/raffle-ancol",
    };

    try {
      const res = await ApiService.apiRequest(requestData);
      const data = res.data.data;

      return data;
    } catch (error) {
      throw error;
    }
  },

  getRaffleAncolDetail: async (raffleId: string) => {
    const requestData = {
      method: "get",
      headers: {
        "Content-Type": "application/json; charset=utf-8",
      },
      url: `admin/raffle-ancol/${raffleId}`,
    };

    try {
      const res = await ApiService.apiRequest(requestData);
      const data = res.data.data;

      return data;
    } catch (error) {
      throw error;
    }
  },

  storeRaffleAncol: async (payload: RaffleAncolPayloadTypes) => {
    const {
      rewardName,
      description,
      qty,
      activePerieodeStart,
      activePerieodeEnd,
      rewardImage,
      isMultipleDraw,
    } = payload;

    const formData = new FormData();
    formData.append("reward_name", rewardName);
    formData.append("description", description);
    formData.append("qty", String(qty));
    formData.append("is_multiple_draw", String(isMultipleDraw));
    formData.append("active_periode_start", activePerieodeStart);
    formData.append("active_periode_end", activePerieodeEnd);
    if (rewardImage) {
      formData.append("img_url", rewardImage);
    }

    const requestData = {
      method: "post",
      headers: {
        "Content-Type": "multipart/form-data; charset=utf-8",
      },
      data: formData,
      url: "admin/raffle-ancol",
    };

    try {
      const res = await ApiService.apiRequest(requestData);
      const data = res.data.data;

      return data;
    } catch (error) {
      throw error;
    }
  },

  updateRaffleAncol: async (
    raffleId: string,
    payload: RaffleAncolPayloadTypes
  ) => {
    const {
      rewardName,
      description,
      qty,
      activePerieodeStart,
      activePerieodeEnd,
      rewardImage,
      isMultipleDraw,
    } = payload;

    const formData = new FormData();
    formData.append("reward_name", rewardName);
    formData.append("description", description);
    formData.append("qty", String(qty));
    formData.append("is_multiple_draw", String(isMultipleDraw));
    formData.append("active_periode_start", activePerieodeStart);
    formData.append("active_periode_end", activePerieodeEnd);
    if (rewardImage) {
      formData.append("img_url", rewardImage);
    }
    formData.append("_method", "PUT");

    const requestData = {
      method: "post",
      headers: {
        "Content-Type": "multipart/form-data; charset=utf-8",
      },
      data: formData,
      url: `admin/raffle-ancol/${raffleId}`,
    };

    try {
      const res = await ApiService.apiRequest(requestData);
      const data = res.data.data;

      return data;
    } catch (error) {
      throw error;
    }
  },

  getGrandPrizeWinners: async (raffleId: string) => {
    const requestData = {
      method: "get",
      headers: {
        "Content-Type": "application/json; charset=utf-8",
      },
      params: {
        catalog_id: raffleId,
      },
      url: "admin/raffle-ancol/winners",
    };

    try {
      const res = await ApiService.apiRequest(requestData);
      const data = res.data?.data ?? res.data;

      return Array.isArray(data) ? data : data?.winners ?? [];
    } catch (error) {
      throw error;
    }
  },

  storeGrandPrizeWinner: async (raffleId: string, payload: any) => {
    const requestData = {
      method: "post",
      headers: {
        "Content-Type": "application/json; charset=utf-8",
      },
      data: {
        catalog_id: raffleId,
        ...payload,
      },
      url: "admin/raffle-ancol/winners",
    };

    try {
      const res = await ApiService.apiRequest(requestData);
      const data = res.data?.data ?? res.data;

      return data;
    } catch (error) {
      throw error;
    }
  },

  deleteGrandPrizeWinner: async (raffleId: string, winnerId: string) => {
    const requestData = {
      method: "post",
      headers: {
        "Content-Type": "application/json; charset=utf-8",
      },
      data: {
        catalog_id: raffleId,
        winner_id: winnerId,
      },
      url: `admin/raffle-ancol/delete-winners`,
    };

    try {
      const res = await ApiService.apiRequest(requestData);
      const data = res.data?.data ?? res.data;

      return data;
    } catch (error) {
      throw error;
    }
  },

  deleteRaffleAncol: async (raffleId: string) => {
    const requestData = {
      method: "delete",
      headers: {
        "Content-Type": "application/json; charset=utf-8",
      },
      url: `admin/raffle-ancol/${raffleId}`,
    };

    try {
      const res = await ApiService.apiRequest(requestData);
      const data = res.data.data;

      return data;
    } catch (error) {
      throw error;
    }
  },
};

export default RaffleAncolService;
